import { BlogSection } from '@/types/blog';

export const finfluencerSection: BlogSection = {
  id: 'finfluencer-warnung',
  title: 'Die Welt der "Finfluencer": Nicht alles Gold, was glänzt',
  content: `
    <p>
      "Finfluencer" – eine Kombination aus "Finance" und "Influencer" – präsentieren sich in sozialen Medien als Finanzexperten. Sie versprechen einfache Wege zum Reichtum, präsentieren beeindruckende Renditen und suggerieren exklusives Wissen. Doch Vorsicht ist geboten:
    </p>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">Typische Warnzeichen unseriöser Finfluencer</h4>
      <ul class="space-y-1.5">
        <li>Versprechen unrealistisch hoher Renditen oder schnellen Reichtums</li>
        <li>Präsentieren komplexe Finanzprodukte als einfache Lösung für alle</li>
        <li>Drängen zu schnellen Entscheidungen mit Zeitdruck ("Jetzt oder nie!")</li>
        <li>Zeigen auffälligen Luxus als "Beweis" ihres finanziellen Erfolgs</li>
        <li>Vermischen Fakten mit persönlichen Meinungen ohne klare Trennung</li>
        <li>Fehlendes Impressum, keine Transparenz bei Qualifikationen</li>
        <li>Keine Offenlegung von Provisionen oder Affiliate-Vergütungen</li>
      </ul>
    </div>
    
    <p>
      Die meisten Finfluencer verdienen ihr Geld nicht mit ihren angeblichen Investmentstrategien, sondern durch Provisionen, bezahlte Partnerschaft und Kurse, die sie verkaufen. Ihre Inhalte sind darauf optimiert, Emotionen wie Neid, Angst oder Gier zu wecken – nicht darauf, fundiertes Finanzwissen zu vermitteln.
    </p>
  `
};
